import { render, staticRenderFns } from "./warehouse-table.vue?vue&type=template&id=495cf15d&scoped=true"
import script from "./warehouse-table.vue?vue&type=script&lang=js"
export * from "./warehouse-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495cf15d",
  null
  
)

export default component.exports